import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../../components/Navbar/Navbar';
import Hero2 from '../../components/hero2/Hero2';
import ProcessSection from '../../components/ProcessSection/ProcessSection';
import WhyChooseUs from '../../components/WhyChooseUs/WhyChooseUs';
import WhyChooseEnhanced from '../../components/WhyChooseEnhanced/WhyChooseEnhanced';
import ProjectSectionS2 from '../../components/ProjectSectionS2/ProjectSectionS2';
import Testimonial from '../../components/Testimonial/Testimonial';
import CtafromSection from '../../components/CtafromSection/CtafromSection';
import StructuredData from '../../components/StructuredData/StructuredData';
// import BlogSection from '../../components/BlogSection/BlogSection'; // Commented out - may use in future
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo-2.svg'

const HomePage2 = () => {
    return (
        <Fragment>
            <Helmet>
                <title>Amped Therapeutics | Advanced Stem Cell Therapy & Regenerative Medicine in Florida</title>
                <meta name="description" content="Florida's pioneering regenerative medicine center. Dr. Eugene Pereira brings concierge stem cell therapy to Sarasota, Fort Myers, Naples. Board-certified FIPP & ABIPP. 25+ years expertise in advanced cellular therapies and interventional pain management." />
                <meta name="keywords" content="stem cell therapy Florida, regenerative medicine Sarasota, concierge regenerative medicine, Dr. Eugene Pereira, PRP therapy Florida, Wharton's Jelly MSC, orthobiologics, Fort Myers stem cells, Naples regenerative medicine" />
                <meta property="og:title" content="Amped Therapeutics - Florida's Premier Concierge Regenerative Medicine" />
                <meta property="og:description" content="Concierge stem cell therapy throughout Florida. Dr. Eugene Pereira brings world-class regenerative medicine directly to premium facilities. Board-certified FIPP & ABIPP with 25+ years experience." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://ampedtherapeutics.com/" />
                <meta property="og:image" content="https://ampedtherapeutics.com/amped-icon.png" />
                <link rel="canonical" href="https://ampedtherapeutics.com/" />
            </Helmet>
            <StructuredData />
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <Hero2 />
            <ProcessSection hclass={"work_section_s2 section-padding"} />
            <WhyChooseUs />
            <ProjectSectionS2 hclass={'project_section_s2 section-padding'} />
            <WhyChooseEnhanced />
            <Testimonial tClass={'testimonial_section testimonial_section_slider section-padding'} />
            <CtafromSection hclass={'ctafrom_section_s2'} />
            {/* <BlogSection tClass={'blog_section section-padding'} /> */}
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage2;